
import * as React from 'react';
import { WithItemCache, IItemCacheStateProps } from '../../../withItemCache/WithItemCache';
import { makeObject } from '../../../../utilities/objects';
import { Action } from '../../../action/Action';
import {
  expireProgressItems,
  getOverallSimpleProgressBreakdown
} from '../../../../operations/progress';
import { isGroupFacet } from '../../../../facets/GroupFacets';

export interface IExpireProgressActionProps {
  itemKeys: string[];
}

/**
 * Item cache action which expires a specified set of progress item groups.
 * This action should always be available for any progress group in a failed state.
 * Executing this action will 'clean up' the progress items so they do not appear to
 * the user.
 */
export class ExpireProgressAction extends React.PureComponent<IExpireProgressActionProps> {
  public render(): JSX.Element {
    const {
      itemKeys
    } = this.props;

    return (
      <WithItemCache>
        { ({ itemCache, dispatch }: IItemCacheStateProps) => {
          const eligibleItemKeys = itemKeys.filter((itemKey: string) => {
            const isProgressGroup = itemCache.demandItemFacet(isGroupFacet, itemKey);

            const { phase } = getOverallSimpleProgressBreakdown(itemCache, { itemKey });

            return isProgressGroup && phase === 'failed';
          });

          const onExecute = async () => {
            dispatch(expireProgressItems({
              items: makeObject(eligibleItemKeys, () => true)
            }));
          };

          return (
            <Action onExecute={ onExecute } isAvailable={ eligibleItemKeys.length > 0 } />
          );
        } }
      </WithItemCache>
    );
  }
}
